<template>
<div class="sidebar">
    <div class="sidebar-inner">
        <!-- ### $Sidebar Header ### -->
        <div class="sidebar-logo">
            <div class="peers ai-c fxw-nw">
                <div class="peer peer-greed">
                    <a class="sidebar-link td-n" href="/">
                    <div class="peers ai-c fxw-nw">
                        <div class="peer">
                            <div class="logo"><img src="@/assets/static/images/logo.png" alt=""></div>
                        </div>
                        <div class="peer peer-greed">
                            <h5 class="lh-1 mB-0 logo-text">{{$Lang('商户管理')}}</h5>
                        </div>
                    </div>
                    </a>
              </div>
              <div class="peer">
                    <div class="mobile-toggle sidebar-toggle">
                        <a href="javascript:removeClass('app','is-collapsed');" class="td-n">
                            <i class="ti-arrow-circle-left"></i>
                        </a>
                    </div>
              </div>
            </div>
        </div>

        <!-- ### $Sidebar Menu ### -->
        <ul class="sidebar-menu scrollable pos-r">
            <li class="nav-item mT-30">
                <router-link :to="{name: 'dashboard'}" :class="{active: active.name == 'dashboard'}" class="sidebar-link" href="/">
                    <span class="icon-holder"><i class="c-blue-500 ti-desktop"></i></span>
                    <span class="title">{{$Lang('概览')}}</span>
                </router-link>
            </li>
            <template v-for="(item, key) in permissionRouters" v-if="!item.hidden && item.children">
            <li class="nav-item dropdown" :key="key" v-on:click.stop.prevent="toggleDropdown($event)" :class="{open: active.parentPath == item.path}" v-if="item.children.length">
                <a class="dropdown-toggle" href="javascript:void(0);">
                    <span class="icon-holder"><i :class="[item.meta.icon, item.meta.iconColor]"></i></span>
                    <span class="title">{{ item.meta.title }}</span>
                    <span class="arrow"><i class="ti-angle-right"></i></span>
                </a>
                <ul class="dropdown-menu">
                    <li v-for="(children, index) in item.children" :key="index">
                        <router-link :to="{name: children.name}" class='sidebar-link' :class="{active: active.name == children.name}" v-if="!children.hidden && hasPermission(children.meta.workName)" @click.native="routeClick(children.name, preRouterName)" >{{ children.meta.title }}
                        </router-link>
                        <router-link :to="{name: 'shopupgrade'}" class='sidebar-link' v-else-if="!children.hidden && !hasPermission(children.meta.workName)">
                            {{ children.meta.title }}
                            <span class="tag"></span>
                        </router-link>
                    </li>
                </ul>
            </li>
            </template>
        </ul>
    </div>
</div>
</template>
<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters([
                'permissionRouters'
            ]),
            active () {
                return { name: this.$route.name, parentPath: this.$route.matched[0].path }
            }
        },
        created () {
            this.preRouterName = this.$route.name
        },
        methods: {
            getItemLi (dom) {
                if (dom.closest) {
                    return dom.closest('li');
                } else {
                    let _d = dom.parentNode;
                    let _nodeName = _d.nodeName.toLowerCase();
                    if (_nodeName === 'li' || _nodeName === 'body') {
                        return _d;
                    } else {
                        return this.getItemLi(_d);
                    }
                }
            },
            toggleDropdown (event) {
                let item = this.getItemLi(event.target);
                item.classList.toggle('open')
            },
            routeClick (to, from) {
                if (to === from) {
                    this.$store.dispatch('fireReloadEvent')
                } else {
                    this.preRouterName = this.$route.name
                }
            }
        },
        data () {
            return {
                preRouterName: ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/layout/SidebarMenu.vue